import { MessageCircle, FileText, Phone } from "lucide-react";
import { SITE, waGeneral } from "@/config/siteConfig";
import { useQuote } from "@/context/QuoteContext";
import { trackEvent } from "@/lib/analytics";

const StickyMobileBar = () => {
  const { openQuote } = useQuote();
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-3 border-t border-black/10 shadow-[0_-4px_16px_rgba(0,0,0,0.12)]" data-testid="mobile-sticky-bar">
      <a href={waGeneral()} target="_blank" rel="noopener noreferrer" data-testid="mobile-bottom-bar-whatsapp"
        onClick={() => trackEvent("whatsapp_click", { location: "sticky_bar" })}
        className="flex items-center justify-center gap-1.5 bg-[#25D366] py-3.5 text-sm font-semibold text-white active:bg-[#1EBE5D]">
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
      <button onClick={() => openQuote()} data-testid="mobile-bottom-bar-quote"
        className="flex items-center justify-center gap-1.5 bg-[#D99B26] py-3.5 text-sm font-semibold text-[#0F2F24] active:bg-[#c98f22]">
        <FileText className="h-4 w-4" /> Get Quote
      </button>
      <a href={`tel:${SITE.phoneRaw}`} data-testid="mobile-bottom-bar-call"
        onClick={() => trackEvent("phone_click", { location: "sticky_bar" })}
        className="flex items-center justify-center gap-1.5 bg-[#0F2F24] py-3.5 text-sm font-semibold text-white active:bg-[#1a4232]">
        <Phone className="h-4 w-4" /> Call Now
      </a>
    </div>
  );
};

export default StickyMobileBar;
